import { CoreTypography, CoreTypographyVariant } from '@ingenico/react-ui/core-typography';
import { SectionCard } from '@ingenico/react-ui/section-card';
import type { PropsWithChildren, ReactNode } from 'react';
import type { DeviceAppVersionCardProps } from './deviceAppVersionCard.model';
import styles from './deviceAppVersionCard.module.scss';

export function DeviceAppVersionCard({
  title,
  subtitle,
  children,
  chipInfo,
}: PropsWithChildren<DeviceAppVersionCardProps>): ReactNode {
  return (
    <SectionCard customClassName={styles.container}>
      <div>
        <div className={styles.titleContainer}>
          <div className={styles.titleWrapper}>
            <CoreTypography variant={CoreTypographyVariant.Title01Medium}>{title}</CoreTypography>
          </div>
          {chipInfo ? (
            <div className={styles.chip}>
              <CoreTypography customClassName={styles.chip__text} variant={CoreTypographyVariant.Body02Medium}>
                {chipInfo}
              </CoreTypography>
            </div>
          ) : undefined}
        </div>
        {subtitle ? (
          <CoreTypography customClassName={styles.subtitle} variant={CoreTypographyVariant.Body02Regular}>
            {subtitle}
          </CoreTypography>
        ) : undefined}
      </div>
      <div className={styles.content}>{children}</div>
    </SectionCard>
  );
}
